import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, { creditId, reversalInfo }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      creditId,
      reversalInfo,
    }),
  };

  const response = await fetch(
    `${URI_TARIFF_PLAN}reversion/create-reversal`,
    opts,
  );
  const jsonResult = await response.json();

  if (response.status >= 400) {
    return Promise.reject(jsonResult);
  }

  return jsonResult.credits;
};
